import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function PrivacyDataStorageIcon(props: IconProps) {
  return (
    <Icon width="72px" height="73px" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8066" r="35.4" fill="white" stroke="white" strokeWidth="1.2" />
      <path
        d="M35.8854 20.303L17.1119 29.5125C17.0434 29.5461 17 29.6158 17 29.6921V34.3818C17 34.4923 17.0895 34.5818 17.2 34.5818H20.9538C21.0643 34.5818 21.1538 34.6714 21.1538 34.7818V53.6341C21.1538 53.7445 21.2433 53.8341 21.3538 53.8341H35.9725H50.5911C50.7016 53.8341 50.7911 53.7445 50.7911 53.6341V34.7818C50.7911 34.6714 50.8807 34.5818 50.9911 34.5818H54.7469C54.8574 34.5818 54.9469 34.4923 54.9469 34.3818V29.6921C54.9469 29.6158 54.9035 29.5461 54.835 29.5125L36.0615 20.303C36.006 20.2757 35.9409 20.2757 35.8854 20.303Z"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <path
        d="M32.187 43.3441H39.6985C40.4717 43.3441 41.0985 43.9709 41.0985 44.7441V53.9937H30.787V44.7441C30.787 43.9709 31.4138 43.3441 32.187 43.3441Z"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <circle
        cx="45.0679"
        cy="24.9305"
        r="6.45153"
        transform="rotate(45 45.0679 24.9305)"
        fill="#40E398"
        stroke="#00584F"
        strokeWidth="1.2"
      />
      <path
        d="M47.2305 22.7192L42.8555 27.0942M42.8555 22.7192L47.2305 27.0942"
        stroke="#00584F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
